export default {
  banner: {
    title: "Authing 合作网络",
    subtitle:
      "我们找到一种方法，可以帮助企业管理员和开发者更简单、高效的完成应用单点登录。",
    "label-one": "用户认证",
    "label-two": "分布国家",
    "label-three": "客户服务",
    "label-four": "服务时间",
  },
  contents: {
    item1: "仅需两步，轻松集成第三方应用",
    item2: "安全开放，轻松找到你所想",
    item3: "集成步骤",
    item4: "已集成上千家应用",
  },
  "application-list": {
    item1: {
      title: "仅需两步，轻松集成第三方应用",
      subtitle:
        "在 Authing 合作网络找到你想要集成的应用。 点击「获取应用」填入该应用的相关配置即可完成。",
      descript1: "1. 在 Authing 合作网络找到你想要集成的应用。",
      descript2: "2. 点击「获取应用」填入该应用的相关配置即可完成。",
    },
    item2: {
      title: "安全开放，轻松找到你所想",
      subtitle:
        "我们提供值得信赖的合作伙伴和第三方集成应用目录，仅仅需要单击几下鼠标即可添加第三方应用到你的 Authing 控制台中。",
      card1: {
        title: "可信赖",
        descript:
          "Authing 在合作网络中提供了多种安全有效的授权方式，并且所有上架的应用都是经过 Authing 严格的安全认证。",
      },
      card2: {
        title: "轻松找到你所想",
        descript:
          "你不仅可以轻松找到所需的集成应用，你还可以在合作网络中浏览到你不了解的可集成应用。",
      },
      card3: {
        title: "开放",
        descript:
          "Authing 会提供一个开放自助的合作网络，方便开发者可以在这个网络里面进行资源互换。",
      },
    },
    item3: {
      title: "集成步骤",
      descript1:
        "下面让我们通过集成「腾讯云」来举例说明合作网络的使用方法，你的用户将快速通过腾讯云账户登录你的应用程序。 首先，如果你还没有免费的 Authing 帐户，请先注册一个。",
      descript2:
        "进入 Authing 控制台后，转到应用市场。在这里，你可以根据需求选择应用集成。 这里，让我们先搜索「腾讯」：",
      descript3: "点击第一个选项「腾讯云」。",
      descript4: "这将带你到腾讯云集成页面，其中包含以下信息：",
      "descript4-list1": "第三方集成应用的说明",
      "descript4-list2": "第三方集成应用地址和隐私政策",
      "descript4-list3": "「获取应用」按钮，它将带你进入应用安装集成配置页。",
      descript5: "单击「接入教程」按钮，你将看到集成应用配置的详细分步说明：",
      descript6:
        "按照帮助文档完成「腾讯云」的配置后，点击「保存」。你将被定向到 Authing 应用列表页为用户分配权限。要测试它是否有效，请选择「体验登录」：",
      descript7:
        "链接正常运行，你将看到「腾讯云控制台」包含用户个人信息的页面：",
      descript8: "就这么简单！总结一下，Authing 合作网络可以帮你：",
      "descript8-list1": "搜索目标应用，一步直达目标",
      "descript8-list2": "自助式教程，帮助你快速上手",
      "descript8-list3": "开放式模式，无边界体验",
    },
    item4: {
      title: "已集成上千家应用",
    },
  },
};
